//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LeftTree from "./components/LeftTree";
import RightTable from "./components/RightTable";
export default {
  name: "BusinessArea",
  components: {
    LeftTree,
    RightTable,
  },
  data() {
    return {
      current: null,
    };
  },
  methods: {
    getCurrentId(data) {
      this.current = data;
      if (data.flag) {
        delete data.flag;
        this.$refs.RightTable.getPersonListbyZoneId(data.id);
      }
    },
  },
  created() {},
};
